module.exports = __webpack_public_path__ + "img/phone.d27429bf.png";